if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return;
      const variantInput = this.form.querySelector('[name="id"]');
      if (variantInput) variantInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    async onSubmitHandler(event) {
      event.preventDefault();
      const button = this.form.querySelector('[type="submit"]');
      // Apps can set a visual loading class before submit. Only an actual
      // request owned by this form should prevent a second submission.
      if (this.submitting || !button || button.disabled) return;
      if (!this.form.reportValidity()) return;
      this.handleErrorMessage();
      const success = this.querySelector('.wbquicksuccess');
      if (success) success.classList.add('hidden');
      this.submitting = true;
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      button.classList.add('loading');

      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      const root = window.Shopify?.routes?.root || '/';
      const notification = document.querySelector('cart-notification');
      const drawerReady = Boolean(window.kachingCartApi?.openCart);
      let added = false;
      try {
        const formData = new FormData(this.form);
        // Preserve the legacy non-PAC fundraiser message on the owning form.
        const buyerMessage = this.form.elements.namedItem('properties[Student Name]');
        if (buyerMessage?.id === 'buyer_message' && buyerMessage.value.trim()) {
          formData.set('properties[Buyer Message]', buyerMessage.value.trim());
        }
        if (notification && !drawerReady) {
          notification.setActiveElement(document.activeElement);
          formData.set('sections', notification.getSectionsToRender().map(section => section.id).join(','));
          formData.set('sections_url', window.location.pathname);
        }
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
          signal: controller.signal
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          this.handleErrorMessage(data.description || data.message || 'This item could not be added. Please check your selection.');
          return;
        }
        added = true;
        if (success) success.classList.remove('hidden');
        if (window.__grCartCount) window.__grCartCount.schedule(120);
        // The cart app watches the request and opens its drawer. Use the theme
        // notification when the app is unavailable, without submitting twice.
        if (!drawerReady && window.kachingCartApi?.openCart) {
          window.kachingCartApi.openCart({ refetchCart: true, focusReturnAnchor: button });
        } else if (!window.kachingCartApi?.openCart) {
          if (notification && data.sections) notification.renderContents(data);
          else window.location.assign(root + 'cart');
        }
      } catch (error) {
        if (added) {
          window.location.assign(root + 'cart');
        } else {
          // Shopify may have accepted a request whose response was lost.
          // Do not automatically retry and accidentally add another item.
          this.handleErrorMessage('We could not confirm the cart update. Check your cart before trying again.', true);
        }
      } finally {
        clearTimeout(timeout);
        this.submitting = false;
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        button.removeAttribute('aria-busy');
        this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      }
    }

    handleErrorMessage(message = '', showCartLink = false) {
      let wrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!wrapper && !message) return;
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'product-form__error-message-wrapper';
        wrapper.setAttribute('role', 'alert');
        this.prepend(wrapper);
      }
      let text = wrapper.querySelector('.product-form__error-message');
      if (!text) {
        text = document.createElement('span');
        text.className = 'product-form__error-message';
        wrapper.append(text);
      }
      wrapper.hidden = !message;
      text.textContent = message;
      if (showCartLink) {
        const link = document.createElement('a');
        link.href = (window.Shopify?.routes?.root || '/') + 'cart';
        link.textContent = 'View cart';
        text.append(' ', link);
      }
    }
  });
}
